<ng-template #accountApmCapReachedTooltip>
  Your account has reached a usage cap for performance events. This chart may be
  missing performance data.
</ng-template>

<div class="col-md-6 col-lg-3">
  <div [ngClass]="{ 'ab-danger-stripes': accountApmCapReached }">
    <h4 class="ab-chart-title">
      <div
        class="ab-chart-title__icon"
        *ngIf="accountApmCapReached"
        [ngbTooltip]="accountApmCapReachedTooltip"
      >
        <img
          src="{{ appEnv.cdnUrl }}/{{
            appEnv.assetsPath
          }}/images/hexagon-alert.svg"
        />
      </div>
      Requests
    </h4>
    <div class="content-mask-container">
      <div class="content-mask" *ngIf="loading">
        <ab-spinner></ab-spinner>
      </div>
      <div class="ab-chart">
        <ab-line-chart
          class="ab-chart__chart"
          [config]="totalRequestsChartConfig"
        ></ab-line-chart>
      </div>
    </div>
  </div>
</div>
<div class="col-md-6 col-lg-3">
  <div [ngClass]="{ 'ab-danger-stripes': accountApmCapReached }">
    <h4 class="ab-chart-title">
      <div
        class="ab-chart-title__icon"
        *ngIf="accountApmCapReached"
        [ngbTooltip]="accountApmCapReachedTooltip"
      >
        <img
          src="{{ appEnv.cdnUrl }}/{{
            appEnv.assetsPath
          }}/images/hexagon-alert.svg"
        />
      </div>
      Response time
    </h4>
    <div class="content-mask-container">
      <div class="content-mask" *ngIf="loading">
        <ab-spinner></ab-spinner>
      </div>
      <div class="ab-chart">
        <ab-line-chart
          class="ab-chart__chart"
          [config]="timingChartConfig"
        ></ab-line-chart>
      </div>
    </div>
  </div>
</div>
<div class="col-md-6 col-lg-3">
  <div [ngClass]="{ 'ab-danger-stripes': accountApmCapReached }">
    <h4 class="ab-chart-title">
      <div
        class="ab-chart-title__icon"
        *ngIf="accountApmCapReached"
        [ngbTooltip]="accountApmCapReachedTooltip"
      >
        <img
          src="{{ appEnv.cdnUrl }}/{{
            appEnv.assetsPath
          }}/images/hexagon-alert.svg"
        />
      </div>
      Error occurrences
    </h4>
    <div class="content-mask-container">
      <div class="content-mask" *ngIf="loading">
        <ab-spinner></ab-spinner>
      </div>
      <div class="ab-chart">
        <ab-line-chart
          class="ab-chart__chart"
          [config]="errorsChartConfig"
        ></ab-line-chart>
      </div>
    </div>
  </div>
</div>
<div class="col-md-6 col-lg-3">
  <div [ngClass]="{ 'ab-danger-stripes': accountApmCapReached }">
    <h4 class="ab-chart-title">
      <div
        class="ab-chart-title__icon"
        *ngIf="accountApmCapReached"
        [ngbTooltip]="accountApmCapReachedTooltip"
      >
        <img
          src="{{ appEnv.cdnUrl }}/{{
            appEnv.assetsPath
          }}/images/hexagon-alert.svg"
        />
      </div>
      User satisfaction (Apdex)
      <div
        class="ab-inline-tooltip"
        ngbTooltip="{{ apdexChartTooltip }}"
        container="body"
      >
        <span
          class="glyphicon glyphicon-question-circle glyphicon--blue"
        ></span>
      </div>
    </h4>
    <div class="content-mask-container">
      <div class="content-mask" *ngIf="loading">
        <ab-spinner></ab-spinner>
      </div>
      <div class="ab-chart">
        <ab-stacked-bar-chart
          class="ab-chart__chart"
          [config]="apdexChartConfig"
        ></ab-stacked-bar-chart>
      </div>
    </div>
  </div>
</div>
